import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Grid } from '@naf/grid';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';
import { Circle } from '@styled-icons/material/Circle';
import EventImage from '../EventImage';

export const MonthWrapper = styled.div`
  margin-top: ${spacing.space56};
`;

export const NoHitWrapper = styled.div`
  margin-top: ${spacing.space56};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NoHitHeader = styled(Text)`
  margin-bottom: ${spacing.space16};
`;

export const NoHitText = styled(Text)`
  margin-bottom: ${spacing.space24};
  margin-top: 0;
  max-width: 350px;
  text-align: center;
`;

export const StyledCalendarImage = styled.img`
  width: 256px;
  height: auto;
  border-radius: ${spacing.space8};
  margin-top: ${spacing.space64};

  @media (max-width: ${breakpoints.s}) {
    width: 150px;
    height: auto;
  }
`;

export const StyledGrid = styled(Grid)`
  row-gap: ${spacing.space32};

  @media (min-width: ${breakpoints.m}) {
    row-gap: ${spacing.space80};
  }
  @media (min-width: ${breakpoints.l}) {
    row-gap: ${spacing.space48};
  }
`;

export const GreenCircle = styled(Circle)`
  color: ${colors.secondary[500]};
`;

export const StyledImage = styled(EventImage)`
  width: 100%;
  min-height: 320px;
  height: auto;
  border-radius: ${spacing.space8};
  flex-shrink: 0;
  object-fit: cover;

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space16};
  }

  @media (max-width: ${breakpoints.m}) {
    min-height: 250px;
  }

  @media (min-width: ${breakpoints.xl}) {
    min-height: 496px;
  }
`;

export const Ingress = styled(Text)`
  margin: ${spacing.space8} 0 ${spacing.space32} 0;
`;

export const TitleLink = styled(Link)`
  text-decoration: none;
`;
